import React from "react";
import { Box } from "rebass/styled-components";

export function DividerAlt(props) {
  return <Box variant="dividerAlt" {...props} />;
}
